import {
  mapHotelMapPoiResponse,
  mapHotelMapSearchResponse,
  type StayMapPoiResultRaw,
  type StayMapSearchResultRaw,
} from "../api/adapters";
import { httpClient } from "../../../lib/http/axios";
import type { ApiEnvelope } from "../../../lib/http/contracts";
import type {
  HotelMapPoi,
  HotelMapSearchResult,
  HotelMapViewport,
} from "../types";

/** 搜索已落库且有合法坐标的房资源酒店管理预览。 */
export async function searchHotelMapPlaces(query: string): Promise<HotelMapSearchResult> {
  const response = await httpClient.get<ApiEnvelope<StayMapSearchResultRaw>>(
    "/resource-stays/map/search",
    {
      params: {
        q: query.trim() || undefined,
        limit: 20,
      },
    },
  );
  const result = mapHotelMapSearchResponse(response.data as unknown);
  if (!result) {
    throw new Error("酒店地图搜索接口返回了无效数据");
  }
  return result;
}

/** 查询当前完整视口内的房资源酒店。 */
export async function fetchHotelMapPois(
  viewport: HotelMapViewport,
  signal?: AbortSignal,
): Promise<HotelMapPoi[]> {
  const response = await httpClient.post<ApiEnvelope<StayMapPoiResultRaw>>(
    "/resource-stays/map/pois",
    viewport,
    { signal, timeout: 30_000 },
  );
  const hotels = mapHotelMapPoiResponse(response.data as unknown, viewport);
  if (!hotels) {
    throw new Error("酒店地图接口未返回完整结果");
  }
  return hotels;
}
